import React, { memo } from "react";

import SvgIcon from "@mui/material/SvgIcon";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
  icon: {
    width: "1.5rem",
    height: "1.5rem",
    fill: "#4C9C2E",
  },
});

export const LeafIcon = memo(() => {
  const styles = useStyles();

  return (
    <SvgIcon viewBox="0 0 24 24" className={styles.icon}>
      <path d="M12.6279 14.8143C12.9665 14.1249 13.4096 13.475 13.9071 12.9441C13.9113 10.1586 15.6127 7.42853 24.191 9.20365C21.6451 9.95253 20.7171 17.0173 14.4798 14.5765C16.1813 11.8544 19.7305 10.3369 21.1978 10.004C19.2665 10.3646 17.749 10.9431 16.5701 11.6246C15.3912 12.3061 14.5509 13.0907 13.9614 13.8594C13.4932 14.5726 13.0877 15.4047 12.8871 16.3437C12.9289 16.9262 12.8829 17.4849 12.7533 18L11.9047 17.3858C12.0886 15.8247 11.7166 14.3824 11.1731 13.1739C10.0945 11.1888 7.84962 8.98176 3.50614 7.49588C5.14488 8.12987 8.97417 10.4795 10.4374 13.9188C2.75784 15.6979 2.99615 7.36517 0.19104 6.07343C10.454 5.45137 11.9172 8.89461 11.403 12.1239C11.9381 12.9084 12.3687 13.8475 12.6279 14.8143Z" />
    </SvgIcon>
  );
});
